export const ROUTE_FORBIDDEN = 'route/ROUTE_FORBIDDEN';
export const ROUTE_AUTH = 'route/ROUTE_AUTH';
export const ROUTE_HOME = 'route/ROUTE_HOME';
export const ROUTE_WELCOME_PAGE = 'route/ROUTE_WELCOME_PAGE';
export const ROUTE_LOGIN = 'route/ROUTE_LOGIN';
export const ROUTE_TRANSACTION_MANAGEMENT = 'route/ROUTE_TRANSACTION_MANAGEMENT';
export const ROUTE_PLACE_AR_TREASURE = 'route/ROUTE_PLACE_AR_TREASURE';
export const ROUTE_PLACE_AR_TREASURE_DETAIL = 'route/ROUTE_PLACE_AR_TREASURE_DETAIL';
export const ROUTE_PLACE_AR_TREASURE_EDIT = 'route/ROUTE_PLACE_AR_TREASURE_EDIT';
export const ROUTE_PLACE_AR_TREASURE_LANDING = 'route/ROUTE_PLACE_AR_TREASURE_LANDING';
export const ROUTE_MY_PLACE_TREASURE = 'route/ROUTE_MY_PLACE_TREASURE';
export const ROUTE_CLUES = 'route/ROUTE_CLUES';
export const ROUTE_CLUE_TEN_STEP = 'route/ROUTE_CLUE_TEN_STEP';
export const ROUTE_MARKET_PLACE = 'route/ROUTE_MARKET_PLACE';
export const ROUTE_MARKETPLACE_EDIT_PROMOTION = 'route/ROUTE_MARKETPLACE_EDIT_PROMOTION';
export const ROUTE_MARKETPLACE_EDIT_PROMOTION_DETAIL =
  'route/ROUTE_MARKETPLACE_EDIT_PROMOTION_DETAIL';
export const ROUTE_BUY_POINT = 'route/ROUTE_BUY_POINT';
export const ROUTE_BUY_POINT_TRANSFER_ETHEREUM = 'route/ROUTE_BUY_POINT_TRANSFER_ETHEREUM';
export const ROUTE_BUY_POINT_TRANSFER_SOLANA  = 'route/ROUTE_BUY_POINT_TRANSFER_SOLANA';
export const ROUTE_SWAP_POINT = 'route/ROUTE_SWAP_POINT';
export const ROUTE_SWAP_POINT_FOR_CRYPTO = 'route/ROUTE_SWAP_POINT_FOR_CRYPTO';
export const ROUTE_WISH_LIST = 'route/ROUTE_WISH_LIST';
export const ROUTE_PLACE_QR_CODE_AND_GOLD_BAR = 'route/ROUTE_PLACE_QR_CODE_AND_GOLD_BAR';
export const ROUTE_PLACE_QR_CODE = 'route/ROUTE_PLACE_QR_CODE';
export const ROUTE_PLACE_GOLD = 'route/ROUTE_PLACE_GOLD';
export const ROUTE_PROFILE = 'route/ROUTE_PROFILE';
export const ROUTE_ABOUT_AND_CONTACT = 'route/ROUTE_ABOUT_AND_CONTACT';
export const ROUTE_PROFILE_REFERRAL = 'route/ROUTE_PROFILE_REFERRAL';
export const ROUTE_INSTAGRAM_CALLBACK = 'route/ROUTE_INSTAGRAM_CALLBACK';
export const ROUTE_X_CALLBACK = 'route/ROUTE_X_CALLBACK';
export const ROUTE_SIGNUP = 'route/ROUTE_SIGNUP';
export const ROUTE_OTP_VERIFICATION = 'route/ROUTE_OTP_VERIFICATION';
export const ROUTE_AUTH_CALLBACK = 'route/ROUTE_AUTH_CALLBACK';
export const ROUTE_SWAP_HISTORY = 'route/ROUTE_SWAP_HISTORY';
export const ROUTE_PLACE_PHYSICAL_QR_CODE = 'route/ROUTE_PLACE_PHYSICAL_QR_CODE';
export const ROUTE_RESET_PASSWORD = 'route/ROUTE_RESET_PASSWORD';
export const ROUTE_CONNECT_XAMAN_CALLBACK = 'route/ROUTE_CONNECT_XAMAN_CALLBACK';
export const ROUTE_IGC_CRYPTO_PAGE = 'ROUTE_IGC_CRYPTO_PAGE';
export const ROUTE_MOBILE_LANDING = 'route/ROUTE_MOBILE_LANDING';
export const ROUTE_PLANS = 'route/ROUTE_PLANS';
export const ROUTE_DELETE_ACCOUNT = 'route/ROUTE_DELETE_ACCOUNT';
export const ROUTE_MERCHANDISE = 'route/ROUTE_MERCHANDISE';
export const ROUTE_MERCHANDISE_DETAIL = 'route/ROUTE_MERCHANDISE_DETAIL';
export const ROUTE_TERMS_AND_CONDITIONS = 'route/ROUTE_TERMS_AND_CONDITIONS';
export const ROUTE_PRIVACY_POLICY = 'route/ROUTE_PRIVACY_POLICY';

export const selectCurrentRoutePayload = (state) => state.location.payload;
export const selectCurrentPage = (state) => state.location.pathname;
export const selectRouteType = (state) => state.location.type;
export const selectRoutesMap = (state) => state.location.routesMap;
export const selectPreviousRoute = (state) => state.location.prev;

export const goToPage = (routeType, payload, rest) => ({
  type: routeType,
  payload: payload,
  ...rest,
});
